import { SpaceVertical } from "../../../common/utils/spacing";
import "./experiences.css";

export const ExperiencesMobile = () => {
  return (
    <div className="m-experiences m-page">
      <h1 className="title"> MES EXPERIENCES </h1>
      <SpaceVertical size={35} />

      <div className="m-experiences-content">
        <OneTimeLine
          date="Janvier 2022 - Mai 2022"
          compagny="SANTECHSEN"
          job="Développeuse d’application"
        />
        <SpaceVertical size={90} />
        <OneTimeLine
          date="Octobre 2020 - Mai 2021"
          compagny="BOKI TECH"
          job="Infographe et développeuse web/mobile"
        />
      </div>
    </div>
  );
};

const OneTimeLine = ({ date, compagny, job }) => {
  return (
    <div className={`one-timeline`}>
      <h4>{date}</h4>
      <div className="deco">
        <div className="line-h"></div>
        <div className="line-v"></div>
        <div className="carre-deco"></div>
        <div className="carre-deco-petit"></div>
      </div>
      <h1>{compagny}</h1>
      <h2>{job}</h2>
    </div>
  );
};
